import PageHeading from "../components/common/PageHeading";
import React from "react";
import SectionTitle from "../components/common/SectionTitle";
import BlogCard from "../components/common/BlogCard";
import { Button } from "@heroui/react";
import { Helmet } from "react-helmet";

const blogData = [{
    id: '1',
    title: 'Oxford College Gampaha: A Beacon of Excellence in Education',
    category: 'Education',
    date: '17 Feb 2025',
    img: 'https://images.pexels.com/photos/2982449/pexels-photo-2982449.jpeg'
}, {
    id: '2',
    title: 'The Oxford College Gampaha Experience: A Day in the Life of a Student',
    category: 'Diversity',
    date: '18 Feb 2025',
    img: 'assets/images/events/preschool-activities/img5.webp'
}, {
    id: '3',
    title: 'Preparing for the Future: Career Guidance and Higher Education Support at Oxford College Gampaha ',
    category: 'Higher Education',
    date: '19 Feb 2025',
    img: 'https://images.pexels.com/photos/6334763/pexels-photo-6334763.jpeg'
}, {
    id: '4',
    title: 'Celebrating Diversity: The Inclusive Culture of Oxford College Gampaha',
    category: 'Diversity',
    date: '20 Feb 2025',
    img: 'https://images.pexels.com/photos/6333733/pexels-photo-6333733.jpeg'
}, {
    id: '5',
    title: 'Innovation in Education: How Oxford College Gampaha is Shaping the Future of Learning',
    category: 'Education',
    date: '21 Feb 2025',
    img: 'https://images.pexels.com/photos/1595391/pexels-photo-1595391.jpeg'
},]

const cardHandler = (id) => {
    window.location.href = `/blog-detailed?id=${id}`
}

const Blog = () => {
    return (<>
        <Helmet>
            <title>Blog - Oxford College</title>
            <meta name="description" content="Stay updated with the latest articles, insights, and news from Oxford College." />
            <meta name="keywords" content="Blog, Articles, News, Updates, Insights, Oxford College" />
            <meta name="author" content="Oxford College - Gampaha" />
            <meta property="og:title" content="Blog - Oxford College - Gampaha" />
            <meta property="og:description" content="Read our latest blog posts and stay informed about Oxford College's updates and educational insights." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://oxfordcollege.lk/blog" />
            <meta property="og:image" content="https://www.facebook.com/photo/?fbid=127196623392555&set=a.127196626725888" />
        </Helmet>

        <div className="flex flex-col">
            <PageHeading
                imgUrl='./assets/images/blogheader.webp'
                alt='Blogs and News'
                title='Blog and News'
            />
        </div>

        {/*    advertisement placeholder    */}
        {/* <div
            className="bg-gray-200 min-h-32 w-full container mx-auto flex items-center justify-center md:rounded-md my-5">
            <span>you can place ads here</span>
        </div> */}

        <section className='mt-8 md:mt-12 lg:mt-16 container mx-auto px-2'>
            <SectionTitle
                titleText={'Latest Posts'}
                textAlignment='start'
            />
        </section>

        <section
            className='mt-5 grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mx-auto container px-2'>
            {blogData.map((blog, index) => (<BlogCard
                key={index}
                cardHandler={() => cardHandler(blog.id)}
                title={blog.title}
                category={blog.category}
                date={blog.date}
                img={blog.img}
            />))}
        </section>

        {/*checks where the length of blog array is greater than 8. if it is shows load more button */}

        {blogData.length > 8 && <div className='flex justify-center mt-8'>
            <Button className={'bg-primary-blue text-white'}>Load More</Button>
        </div>
        }
{/* 
        <div
            className="bg-gray-200 min-h-32 w-full container mx-auto flex items-center justify-center md:rounded-md my-5">
            <span>you can place ads here</span>
        </div> */}
    </>)
}

export default Blog